export default __webpack_public_path__ + "images/0xeff2a458e464b07088bdb441c21a42ab4b61e07e.png";